import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7f7843fc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "formContainer" }
const _hoisted_2 = { class: "formContainer__element" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "companyName" }, "Compañia", -1))
const _hoisted_4 = { class: "formContainer__element" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "companyNit" }, "Nit / Id", -1))
const _hoisted_6 = { class: "formContainer__element" }
const _hoisted_7 = {
  key: 0,
  type: "submit",
  class: "formContainer__element__button--create"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-symbols-outlined" }, "person_add", -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = {
  key: 1,
  class: "formContainer__element__button--edit"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-symbols-outlined" }, "edit", -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = {
  key: 2,
  class: "formContainer__element__button--cancel"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-symbols-outlined" }, "cancel", -1))
const _hoisted_15 = [
  _hoisted_14
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", {
      onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.sendCreationRequest && _ctx.sendCreationRequest(...args)), ["prevent"]))
    }, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _withDirectives(_createElementVNode("input", {
          type: "text",
          id: "companyName",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.companyName) = $event))
        }, null, 512), [
          [_vModelText, _ctx.companyName]
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _withDirectives(_createElementVNode("input", {
          type: "text",
          id: "companyNit",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.companyNit) = $event))
        }, null, 512), [
          [_vModelText, _ctx.companyNit]
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        (_ctx.usedFor === 'creation')
          ? (_openBlock(), _createElementBlock("button", _hoisted_7, _hoisted_9))
          : _createCommentVNode("", true),
        (_ctx.usedFor === 'edit')
          ? (_openBlock(), _createElementBlock("button", _hoisted_10, _hoisted_12))
          : _createCommentVNode("", true),
        (_ctx.usedFor === 'edit' || _ctx.usedFor === 'creation')
          ? (_openBlock(), _createElementBlock("button", _hoisted_13, _hoisted_15))
          : _createCommentVNode("", true)
      ])
    ], 32)
  ]))
}